var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.25c-1.468-1.187-1.562-5.094.75-6 1.227-.48 1.624 2.203 4.031 1.531.466-.13 1.563.531 1.163 1.54M4.684 3.616c.473.35.88.777 1.228 1.36.304.51.98 1.928.361 2.729-.7.905-2.728 1.21-2.728 2.045 0 .628.889 1.345 1.364 2.045.714 1.054.389 2.075 0 2.727-.202.338-.541.612-.899.828M16.35 8.25a7.5 7.5 0 1 1-6.259-5.921M12.75 6.75V9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 3.75,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGrey);
export default __webpack_public_path__ + "static/media/map-grey.d86e1662644a5b98f62faebfb2c968cd.svg";
export { ForwardRef as ReactComponent };